import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { utilService } from 'services/util-service';
import { IStoreState } from 'store/modules';
import { Publisher } from './types';

const COLOR = {
  r: css`
    background: linear-gradient(180deg, #0086ff 0%, #005099 100%);
  `,
  v: css`
    background: linear-gradient(180deg, #e63528 0%, #801d16 100%);
  `,
};
const LABEL = { r: '구조대', v: '요구조자' };

interface ViewerListProps {
  publishers: Publisher[];
  selectedName?: string;
  onSelect: (name: string) => void;
}

const ViewerList = ({ publishers, selectedName, onSelect }: ViewerListProps) => {
  const users = useSelector((store: IStoreState) => store.MainReducer.users);
  const rescues = useSelector((store: IStoreState) => store.MainReducer.rescues);

  const getType = (phone: string): 'r' | 'v' => {
    if (users.vDatas.find((data) => data.phone === phone) !== undefined) return 'v';
    return 'r';
  };

  const findRescueName = (phone: string): string | undefined => {
    const traverse = (node: any): any => {
      if (Array.isArray(node)) {
        for (const sub of node) {
          const found = traverse(sub);
          if (found) return found;
        }
        return null;
      }
      if (node.lv === 4 && Array.isArray(node.children)) {
        for (const child of node.children) {
          if (child.value === phone) return child;
        }
      }
      if (node.children && node.children.length > 0) {
        for (const sub of node.children) {
          const found = traverse(sub);
          if (found) return found;
        }
      }
      return null;
    };
    const result = traverse(rescues);
    return result ? result.vesselinfo : undefined;
  };

  return (
    <ListTemplate>
      <ListHeader>전송자 ({publishers.length})</ListHeader>
      <ListWrap>
        {publishers.map((item) => {
          const type = getType(item.name);
          const rescueName = findRescueName(item.name);
          return (
            <ItemWrap key={item.name} $selected={item.name === selectedName} onClick={() => onSelect(item.name)}>
              <TypeBadge $type={type}>{LABEL[type]}</TypeBadge>
              <ItemText>
                <NameText>{rescueName ?? utilService.isMobileFormat(item.name)}</NameText>
                {rescueName && <PhoneText>{utilService.isMobileFormat(item.name)}</PhoneText>}
              </ItemText>
            </ItemWrap>
          );
        })}
      </ListWrap>
    </ListTemplate>
  );
};

const ListTemplate = styled.div`
  display: flex;
  flex-direction: column;
  width: 16rem;
  background: #2d4254;
  border-right: 1px solid #000;
  @media (max-width: 768px) {
    width: 100%;
    height: 7.5rem;
    border-right: none;
    border-bottom: 1px solid #000;
  }
`;
const ListHeader = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
  padding: 0 0.75rem;
  font-size: 16px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0;
  color: #ffffff;
  border-bottom: 1px solid #000;
`;
const ListWrap = styled.ul`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  @media (max-width: 768px) {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
  }
`;
const ItemWrap = styled.li<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  height: 45px;
  padding: 0 0.75rem;
  border-bottom: 1px solid #000;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#006ac8' : 'transparent')};
  :hover {
    background: ${({ $selected }) => ($selected ? '#006ac8' : '#123253')};
  }
  @media (max-width: 768px) {
    flex: 0 0 auto;
    border-bottom: none;
    border-right: 1px solid #000;
  }
`;
const TypeBadge = styled.span<{ $type: 'r' | 'v' }>`
  flex: 0 0 auto;
  padding: 0.15rem 0.45rem;
  border-radius: 0.3rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #ffffff;
  ${({ $type }) => COLOR[$type]}
`;
const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.2rem;
  min-width: 0;
`;
const NameText = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const PhoneText = styled.span`
  font-size: 0.8rem;
  line-height: 100%;
  color: #b8c7d9;
`;

export default ViewerList;
